var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCadastrosHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2388_5192",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2388_5192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29018 17.9722H15.2098C15.3205 17.9722 15.4174 17.9306 15.5004 17.8472C15.5835 17.7639 15.625 17.6667 15.625 17.5556C15.625 17.4259 15.5835 17.3241 15.5004 17.25C15.4174 17.1759 15.3205 17.1389 15.2098 17.1389H8.29018C8.17946 17.1389 8.08259 17.1806 7.99955 17.2639C7.91652 17.3472 7.875 17.4444 7.875 17.5556C7.875 17.6852 7.91652 17.787 7.99955 17.8611C8.08259 17.9352 8.17946 17.9722 8.29018 17.9722ZM8.29018 13.4167H15.2098C15.3205 13.4167 15.4174 13.375 15.5004 13.2917C15.5835 13.2083 15.625 13.1019 15.625 12.9722C15.625 12.8611 15.5835 12.7639 15.5004 12.6806C15.4174 12.5972 15.3205 12.5556 15.2098 12.5556H8.29018C8.17946 12.5556 8.08259 12.5972 7.99955 12.6806C7.91652 12.7639 7.875 12.8704 7.875 13C7.875 13.1111 7.91652 13.2083 7.99955 13.2917C8.08259 13.375 8.17946 13.4167 8.29018 13.4167ZM5.52232 22C5.09792 22 4.7381 21.8519 4.44286 21.5556C4.14762 21.2593 4 20.8981 4 20.4722V3.52778C4 3.10185 4.14762 2.74074 4.44286 2.44444C4.7381 2.14815 5.09792 2 5.52232 2H14.158C14.3795 2 14.5824 2.04167 14.767 2.125C14.9515 2.20833 15.1176 2.31481 15.2652 2.44444L19.0571 6.25C19.1863 6.39815 19.2924 6.56482 19.3754 6.75C19.4585 6.93519 19.5 7.13889 19.5 7.36111V20.4722C19.5 20.8981 19.3524 21.2593 19.0571 21.5556C18.7619 21.8519 18.4021 22 17.9777 22H5.52232ZM14.3518 6.36111C14.3518 6.56482 14.4302 6.74074 14.5871 6.88889C14.7439 7.03704 14.9146 7.11111 15.0991 7.11111H18.642L14.3518 2.86111V6.36111Z",
    fill: "#58C5C6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadastrosHover);
export default __webpack_public_path__ + "static/media/cadastros_hover.a7fcce7cd70aa6ccb1b646836f1a10cc.svg";
export { ForwardRef as ReactComponent };